var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.566 22.82a1.95 1.95 0 0 1-1.947-1.947 1.95 1.95 0 0 1 1.947-1.947 1.95 1.95 0 0 1 1.947 1.947 1.95 1.95 0 0 1-1.947 1.947zM17.575 22.82a1.95 1.95 0 0 1-1.947-1.947 1.95 1.95 0 0 1 1.947-1.947 1.95 1.95 0 0 1 1.947 1.947 1.95 1.95 0 0 1-1.947 1.947zM22.52 8.538a2.297 2.297 0 0 0-1.834-.904H6.209l-.548-2.059A1.95 1.95 0 0 0 3.778 4.13h-1a.78.78 0 0 0 0 1.558h1c.177 0 .332.12.378.29l2.58 9.675A2.315 2.315 0 0 0 8.97 17.37h10.354a2.315 2.315 0 0 0 2.234-1.717l1.363-5.11c.186-.7.04-1.43-.401-2.004zm-11.862 6.634a.78.78 0 0 1-.893-.645l-.611-3.786a.779.779 0 1 1 1.537-.248l.612 3.786a.779.779 0 0 1-.645.893zm4.191-.918a.78.78 0 0 1-1.557 0v-3.505a.78.78 0 0 1 1.557 0v3.505zm4.035-3.513-.612 3.786a.78.78 0 0 1-1.537-.248l.61-3.786a.778.778 0 1 1 1.539.248z",
    fill: "#FFE14B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusket);
export default __webpack_public_path__ + "static/media/busket.bcfc01dc17c5e469668579e38a687af9.svg";
export { ForwardRef as ReactComponent };